import { combineReducers } from '@reduxjs/toolkit'
import session, { SessionState } from './sessionSlice'
import user, { UserState } from './userSlice'
import role, { RoleState } from './roleSlice'

const reducer = combineReducers({
    session,
    user,
    role,
})

export type AuthState = {
    session: SessionState
    user: UserState
    role: RoleState
}

export * from './sessionSlice'
export * from './userSlice'
export * from './roleSlice'

export default reducer
